import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

// Hero Banner
import bannerImage from "../components/Assets/bannerimage.jpg";

// Fixture Images
import biwFixture from "../components/Assets/BIWCMM.webp";
import apertureGauge from "../components/Assets/APERTUREGAUGES.webp";

import Card from './../components/Commanbackgroundcard/Card';

const FixturesToolingsPage = () => {
  // Fixtures Data
  const fixtures = [
    {
      name: "BIW CMM Checking Fixtures",
      image: biwFixture,
      description:
        "High-precision BIW (Body-in-White) CMM checking fixtures designed to ensure dimensional accuracy, repeatability, and consistent quality during automotive manufacturing and inspection processes.",
    },
    {
      name: "Aperture Gauges – D-Pillar Glass / Head Lamp / Tail Lamp",
      image: apertureGauge,
      description:
        "Custom-designed aperture gauges for critical automotive components like D-pillars, headlamps, and tail lamps. These tools ensure repeatable measurement accuracy, improve assembly performance, and enhance production safety.",
    },
  ];

  const industries = [
    { name: "Automotive", icon: "🚗" },
    { name: "Pharmaceuticals", icon: "💊" },
    { name: "FMCG", icon: "📦" },
    { name: "Heavy Engineering", icon: "⚙️" },
    { name: "Electronics", icon: "💡" },
  ];

  const whyChoose = [
    "Specialized expertise in precision fixtures & tooling",
    "Reliable, repeatable solutions for quality assurance",
    "Tailor-made designs to meet manufacturing needs",
    "Improved safety and accuracy in production lines",
    "Trusted by leading automotive & industrial clients",
    "Strong Portfolio of Successful Global Implementations",
  ];

  return (
    <div className="bg-gray-100 min-h-screen">
      <Navbar />

      {/* Page Heading Card */}
      <Card text="FIXTURES & TOOLINGS" />

      {/* Intro Section */}
      <section className="py-16 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            Precision <span className="text-[#F49100]">Fixtures & Toolings</span>
          </h2>
          <p className="text-gray-700 text-base lg:text-lg leading-relaxed max-w-4xl mx-auto">
            We design and manufacture advanced fixtures and tooling solutions
            for welding, checking, and component holding. Our products deliver
            dimensional accuracy, repeatable quality, and safer production
            environments. From BIW checking fixtures to aperture gauges, every
            solution is engineered for precision, efficiency, and industry
            compliance.
          </p>
        </div>
      </section>

      {/* Fixtures Section */}
      <section className="py-16 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 text-center mb-4">
            Our <span className="text-[#F49100]">Tooling Solutions</span>
          </h2>
          <p className="text-gray-700 text-center mb-12 max-w-3xl mx-auto">
            Engineered for accuracy, efficiency, and durability in modern
            manufacturing lines.
          </p>
          <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-8">
            {fixtures.map((fixture, i) => (
              <article
                key={i}
                className="bg-white rounded-2xl shadow-md hover:shadow-xl transition transform hover:-translate-y-2 duration-500 overflow-hidden border border-gray-100"
              >
                <div className="relative group">
                  <img
                    src={fixture.image}
                    alt={fixture.name}
                    className="w-full h-100 object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    {fixture.name}
                  </h3>
                  <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                    {fixture.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Industry Applications */}
      <section className="py-16 px-6 lg:px-12 bg-gray-50">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            Industry <span className="text-[#F49100]">Applications</span>
          </h2>
          <p className="text-gray-700 mb-12 max-w-3xl mx-auto">
            Our fixtures and tooling solutions are trusted across industries for
            precision and performance.
          </p>
          <div className="grid sm:grid-cols-2 md:grid-cols-5 gap-8 max-w-5xl mx-auto">
            {industries.map((ind, i) => (
              <div
                key={i}
                className="flex flex-col items-center p-6 bg-white rounded-2xl shadow-md hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
              >
                <div className="text-5xl mb-4">{ind.icon}</div>
                <p className="text-gray-700 font-semibold text-center">
                  {ind.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 text-center mb-4">
            Why Choose <span className="text-[#F49100]">Us</span>
          </h2>
          <p className="text-gray-700 text-center mb-12 max-w-3xl mx-auto">
            Trusted for precision, innovation, and unmatched quality in every
            fixture we deliver.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {whyChoose.map((point, i) => (
              <div
                key={i}
                className="flex items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition duration-300"
              >
                <div className="w-3 h-3 bg-[#F49100] rounded-full mr-4 flex-shrink-0"></div>
                <p className="text-gray-700 font-medium">{point}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-6 lg:px-12 bg-[#F49100] text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Need Precision Fixtures for Your Line?
          </h2>
          <p className="mb-8 text-lg leading-relaxed">
            Contact us today for custom-designed tooling solutions to ensure
            accuracy, repeatability, and improved production efficiency.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-block px-8 py-4 bg-white text-[#F49100] font-bold rounded-lg hover:bg-gray-100 transition duration-300"
            >
              Contact Us
            </a>
            {/* <a
              href="/quote"
              className="inline-block px-8 py-4 bg-transparent border-2 border-white text-white font-bold rounded-lg hover:bg-white hover:text-[#F49100] transition duration-300"
            >
              Request Quote
            </a> */}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FixturesToolingsPage;
